import { Directive } from '@angular/core';

@Directive({
   // tslint:disable-next-line: directive-selector
   selector: '[actionStart]'
})
export class ActionStartDirective {

   constructor() { }

}
